/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthorizedApp } from './AuthorizedApp';
import {
    AuthorizedAppFromJSON,
    AuthorizedAppFromJSONTyped,
    AuthorizedAppToJSON,
} from './AuthorizedApp';

/**
 * 
 * @export
 * @interface AuthorizedApps
 */
export interface AuthorizedApps {
    /**
     * 
     * @type {Array<AuthorizedApp>}
     * @memberof AuthorizedApps
     */
    data?: Array<AuthorizedApp>;
}

/**
 * Check if a given object implements the AuthorizedApps interface.
 */
export function instanceOfAuthorizedApps(value: object): value is AuthorizedApps {
    let isInstance = true;

    return isInstance;
}

export function AuthorizedAppsFromJSON(json: any): AuthorizedApps {
    return AuthorizedAppsFromJSONTyped(json, false);
}

export function AuthorizedAppsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizedApps {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AuthorizedAppFromJSON)),
    };
}

export function AuthorizedAppsToJSON(value?: AuthorizedApps | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AuthorizedAppToJSON)),
    };
}

